import React, { useState, useEffect } from 'react';
import './Pagination.css';
import { ArrowRight, ArrowLeft } from 'lucide-react';
const Pagination = ({ totalPages = 1, onPageChange, pageCount }) => {
    const effectiveTotalPages = totalPages > 0 ? totalPages : 1;
    const initialPage = pageCount > 0 && pageCount <= effectiveTotalPages ? pageCount : 1;
    const [currentPage, setCurrentPage] = useState(initialPage);

    // Keep internal currentPage in sync when parent provides a new pageCount or totalPages
    useEffect(() => {
        // Ensure current page is at least 1 and not greater than effectiveTotalPages
        const newPage = pageCount > 0 && pageCount <= effectiveTotalPages ? pageCount : 1;
        setCurrentPage(newPage);
    }, [pageCount, totalPages]);

    const handlePageChange = (page) => {
        if (page < 1 || page > totalPages) return;
        setCurrentPage(page);
        onPageChange(page);
    };

    const createPagination = () => {
        let liTags = [];
        let beforePage = Math.max(1, currentPage - 1);
        let afterPage = Math.min(currentPage + 1, effectiveTotalPages);

        if (currentPage > 1) {
            liTags.push(
                <li key="prev" className="btn prev" onClick={() => handlePageChange(currentPage - 1)}>
                    <span className='flex items-center'><ArrowLeft /> Prev</span>
                </li>
            );
        } else {
            liTags.push(
                <li key="prev" className="btn prev disabled">
                    <span className='flex items-center'><ArrowLeft /> Prev</span>
                </li>
            );
        }
        if (currentPage > 2) {
            liTags.push(
                <li key={1} className="first numb" onClick={() => handlePageChange(1)}>
                    <span>1</span>
                </li>
            );
            if (currentPage > 3) {
                liTags.push(
                    <li key="dots1" className="dots">
                        <span>...</span>
                    </li>
                );
            }
        }

        for (let page = beforePage; page <= afterPage; page++) {
            liTags.push(
                <li key={page} className={`numb ${currentPage === page ? 'active' : ''}`} onClick={() => handlePageChange(page)}>
                    <span>{page}</span>
                </li>
            );
        }

        if (currentPage < effectiveTotalPages - 1) {
            if (currentPage < effectiveTotalPages - 2) {
                liTags.push(
                    <li key="dots2" className="dots">
                        <span>...</span>
                    </li>
                );
            }
            liTags.push(
                <li key={effectiveTotalPages} className="last numb" onClick={() => handlePageChange(effectiveTotalPages)}>
                    <span>{effectiveTotalPages}</span>
                </li>
            );
        }

        if (currentPage < effectiveTotalPages) {
            liTags.push(
                <li key="next" className="btn next" onClick={() => handlePageChange(currentPage + 1)}>
                    <span className='flex items-center'>Next <ArrowRight /></span>
                </li>
            );
        } else {
            liTags.push(
                <li key="next" className="btn next disabled">
                    <span className='flex items-center'>Next <ArrowRight /></span>
                </li>
            );
        }

        return liTags;
    };

    return (
        <div className="pagination">
            <ul>
                {createPagination()}
            </ul>
        </div>
    );
};

export default Pagination;
